export enum NomineeInvestmentStatus {
  PendingCustomerSignature = 'PENDING_CUSTOMER_SIGNATURE',
  InReview = 'IN_REVIEW',
  Declined = 'DECLINED',
  Approved = 'APPROVED',
  AwaitingFirstClose = 'AWAITING_FIRST_CLOSE',
  AwaitingPayment = 'AWAITING_PAYMENT',
  Invested = 'INVESTED',
}

export interface NomineeInvestment {
  amount: number;
  createdAt: string;
  investmentDate: string;
  outstandingShareBalance: number;
  productId: number;
  productName: string;
  status: NomineeInvestmentStatus;
  transactionId: number;
  updatedAt: string;
}

export interface NomineeInvestmentAttribution {
  id: number;
  amount: number;
  shareholderFullName: string;
  nomineeCustomerId: string;
  shares: number;
  transactionId: number;
}
